import React from 'react';
import useShowInvitationModal from './useShowInvitationModal';
import useAppSelector from '../app/redux/useAppSelector';
import Button from '../components/Button';
import { MenuItem } from '../components/Menu';
import Tooltip from '../components/Tooltip';
import { UserType } from '../graphql/generated/graphql';
import memberIcon from '../icons/non-prefilled/16x16/member.svg';
import memberAddIcon from '../icons/non-prefilled/16x16/memberAdd.svg';

const disabledMessage =
  'Inviting members is\ndisabled until your email\nhas been verified';

interface InviteMenuItemProps {
  withIcon?: boolean;
}

export const InviteMenuItem = ({ withIcon }: InviteMenuItemProps) => {
  const isVerified = useAppSelector(
    (state) => state.session.organization.isVerified,
  );
  const currentUser = useAppSelector((state) => state.session.user);
  const showInvitationModal = useShowInvitationModal();

  if (currentUser.type === UserType.Guest) {
    return null;
  }

  return (
    <MenuItem
      onClick={showInvitationModal}
      disabled={!isVerified}
      tooltip={isVerified ? undefined : disabledMessage}
      icon={withIcon ? memberAddIcon : undefined}
    >
      Invite teammates
    </MenuItem>
  );
};

export const InviteButton = () => {
  const isVerified = useAppSelector(
    (state) => state.session.organization.isVerified,
  );
  const currentUser = useAppSelector((state) => state.session.user);
  const showInvitationModal = useShowInvitationModal();

  if (currentUser.type === UserType.Guest) {
    return null;
  }

  const inviteButton = (
    <Button
      variant="secondary"
      icon={memberIcon}
      size="small"
      onClick={showInvitationModal}
      disabled={!isVerified}
    >
      Invite teammates
    </Button>
  );

  return isVerified ? (
    inviteButton
  ) : (
    <Tooltip content={disabledMessage}>{inviteButton}</Tooltip>
  );
};
